<template>
  <de-layout-content>
    <div class="teamManage">
      <a-tabs v-model="activeKey" @tabClick="handleTab">
        <a-tab-pane key="team" tab="运动队">
          <sport-team @operate="operate" />
        </a-tab-pane>
        <a-tab-pane key="group" tab="运动组">
          <sport-group :teamId="teamId" />
        </a-tab-pane>
      </a-tabs>
    </div>
  </de-layout-content>
</template>

<script>
import sportTeam from "./sportTeam.vue";
import sportGroup from "./sportGroup.vue";


export default {
  data() {
    return {
      activeKey: "team",
      teamId: null
    };
  },
  components: {
    sportTeam,
    sportGroup
  },
  methods: {
    operate(id) {
      this.teamId = id
      this.activeKey = "group";
    },
    handleTab(tab) {
      this.teamId = null
    }
  },
  created() {},
};
</script>
<style lang='less' scoped>
</style>
